import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './amplify-config';

export function amplifyInitializer(): () => void {
  return (): void => {
    Amplify.configure(amplifyConfig);
  };
}
